'use client';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { getCJPageType } from 'helpers/utils/cjTagDataHelpers';
import { gtmPageView, PageViewEvent } from 'helpers/utils/gtm-events/gtmMisc';
import { gtmUserIdentity } from 'helpers/utils/gtm-events/gtmUser';
import { useAccount } from 'frontastic';

export default function GTMPageViewTracker({ referer, pageTypeVal }: { referer: string; pageTypeVal?: string }) {
  const path = usePathname();

  const pageType = getCJPageType({
    locale: 'en',
    path: path,
  });
  const { account, isResolved } = useAccount();
  const [hasTriggerEvent, setHasTriggerEvent] = useState<boolean>(false);

  const handlePageView = () => {
    const pageViewObject: PageViewEvent = {
      page: {
        pageType: pageTypeVal ?? pageType,
        page_location: window.location.href,
        page_title: document.title,
        page_referrer: referer,
        page_path: window.location.pathname,
        timestamp: new Date().toISOString(),
      },
      user: {
        login_status: false,
      },
    };

    if (account) {
      pageViewObject.user = {
        customer_type: account.customerType ?? '',
        hashed_user_id: account.accountId ?? '',

        email: account.email ?? '',
        hashed_email: account.emailHash ?? '',
        login_status: true,

        isTradeAccount: !!account.isTradeAccount,
      };
      gtmUserIdentity(account);
    }
    // TODO: conditional to detect blogPage
    if (pageType === 'blogPage') {
    }

    gtmPageView(pageViewObject);
  };

  useEffect(() => {
    const checkDataLayer = () => {
      if (typeof window !== 'undefined' && window.dataLayer && isResolved && !hasTriggerEvent) {
        handlePageView();
        setHasTriggerEvent(true);
        clearInterval(interval);
      }
    };

    const interval = setInterval(checkDataLayer, 200);
    return () => clearInterval(interval);
  }, [isResolved]);

  return <></>;
}
